import { defineComponent as _defineComponent } from 'vue'
import VModal from "@/components/vModal.vue";
import {useStoreState} from "@/hooks/useStoreState";

type vTrialEndUpsellModalProps = {
  showModal: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'vTrialEndUpsellModal',
  props: {
    showModal: { type: Boolean, default: false }
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as { showModal: boolean };





const store = useStoreState();

return { __sfc: true,props, emit, store, VModal }
}

})